import { render, staticRenderFns } from "./MessageTemplateItemV2026.vue?vue&type=template&id=8af4f1d8&scoped=true"
import script from "./MessageTemplateItemV2026.vue?vue&type=script&lang=js"
export * from "./MessageTemplateItemV2026.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplateItemV2026.vue?vue&type=style&index=0&id=8af4f1d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af4f1d8",
  null
  
)

export default component.exports